import { MenuModel } from '@bo-client/core/navigation/menu.model';
import { path } from '@bo-client/shared/constants/path';

export const FooterMenu: MenuModel[] = [
  {
    label: 'Datenschutz',
    icon: null,
    link: '/' + path.privacyPolicy,
    roles: ['ALL_USERS']
  },
  {
    label: 'Impressum',
    icon: null,
    link: '/' + path.termsConditions,
    roles: ['ALL_USERS']
  }
];
